import React, { useEffect, useState } from "react";
import PreviewMeetingCard from "./PreviewMeetingCard";
import PreviewMeetingUsersCard from "./PreviewMeetingUsersCard";
import PreviewMeetingMailFilesCard from "./PreviewMeetingMailFilesCard";
import { getMeetingPreviewApi } from "api/meeting";
import { Box } from "@mui/material";
import LoadingPopUp from "../LoadingPopup";
import PreviewSuggestionListCard from "./PreviewSuggestionListCard";

function PreviewMeetingDetailCard({ meeting }) {
    const [meetingUsers, setMeetingUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [suggestionList, setSuggestionList] = useState([]);
    const [mailFiles, setMailFiles] = useState([]);
    const [decisions, setDecisions] = useState([]);
    const [votes, setVotes] = useState([]);
    const [reviews, setReviews] = useState([]);
    const [decisionFiles, setDecisionFiles] = useState([]);

    useEffect(() => {
        const getAPI = async () => {
            if (!meeting?.id) return;
            setLoading(true);
            try {
                const res = await getMeetingPreviewApi(meeting.id);
                if (!res?.status || !res.data) {
                    setMeetingUsers([]);
                    setSuggestionList([]);
                    setMailFiles([]);
                    setDecisions([]);
                    setVotes([]);
                    setReviews([]);
                    setDecisionFiles([]);
                    return;
                }
                const {
                    meetingUsers: users = [],
                    decisions: decisionList = [],
                    votes: voteList = [],
                    reviews: reviewList = [],
                    suggestions = [],
                    decisionFiles: files = [],
                } = res.data;

                setMeetingUsers(users);
                setDecisions(decisionList);
                setVotes(voteList);
                setReviews(reviewList);
                setSuggestionList(suggestions);
                setDecisionFiles(files);
                setMailFiles(files.filter(item => item.decisionId === 0));
            } catch (error) {
                console.error("Toplantı önizleme alınamadı:", error);
            } finally {
                setLoading(false);
            }
        };
        getAPI();
    }, [meeting]);

    return (
        <Box>
            <LoadingPopUp open={loading} />
            {!loading && (
                <>
                    <PreviewMeetingCard
                        meeting={meeting}
                        meetingUsers={meetingUsers}
                        decisions={decisions}
                        votes={votes}
                        reviews={reviews}
                        decisionFiles={decisionFiles}
                        usersSectionId="preview-meeting-users"
                    />

                    {suggestionList.length > 0 && (
                        <>
                            <Box sx={{ marginY: 1 }} />
                            <PreviewSuggestionListCard mainData={suggestionList} meetingUsers={meetingUsers} />
                        </>
                    )}

                    <Box sx={{ marginY: 1 }} />

                    <Box id="preview-meeting-users" sx={{ scrollMarginTop: 8 }}>
                        <PreviewMeetingUsersCard
                            meeting={meeting}
                            meetingUsers={meetingUsers}
                            votes={votes}
                            decisions={decisions}
                        />
                    </Box>

                    <PreviewMeetingMailFilesCard meeting={meeting} mailFiles={mailFiles} />

                </>
            )}
        </Box>
    );
}

export default PreviewMeetingDetailCard;
